module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pgInner euserEdit"
  }, [_c('div', {
    staticClass: "headBar"
  }, [_vm._v("新建用户")]), _vm._v(" "), _c('div', {
    staticClass: "pgbody",
    style: ('height:' + _vm.pageH + 'px;')
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules,
      "show-message": false
    }
  }, [_c('div', {
    staticClass: "textLine clearfix"
  }, [_c('div', {
    staticClass: "itemGp"
  }, [_c('div', {
    staticClass: "iName"
  }, [_vm._v("真实姓名")]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "name"
    }
  }, [_c('el-input', {
    staticClass: "iInp",
    attrs: {
      "size": "middle"
    },
    model: {
      value: (_vm.params.name),
      callback: function($$v) {
        _vm.$set(_vm.params, "name", $$v)
      },
      expression: "params.name"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "itemGp"
  }, [_c('div', {
    staticClass: "iName"
  }, [_vm._v("手机号")]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "phoneNumber"
    }
  }, [_c('el-input', {
    staticClass: "iInp",
    attrs: {
      "disabled": true,
      "size": "middle"
    },
    model: {
      value: (_vm.params.phoneNumber),
      callback: function($$v) {
        _vm.$set(_vm.params, "phoneNumber", $$v)
      },
      expression: "params.phoneNumber"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "textLine clearfix"
  }, [_c('div', {
    staticClass: "itemGp"
  }, [_c('div', {
    staticClass: "iName"
  }, [_vm._v("所属企业")]), _vm._v(" "), _c('div', {
    staticClass: "iContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "cqjQiyeEnterpriseId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "270px"
    },
    attrs: {
      "filterable": "",
      "remote": "",
      "placeholder": "请输入关键词",
      "size": "medium",
      "remote-method": _vm.entSeek,
      "loading": _vm.loading
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.params.cqjQiyeEnterpriseId),
      callback: function($$v) {
        _vm.$set(_vm.params, "cqjQiyeEnterpriseId", $$v)
      },
      expression: "params.cqjQiyeEnterpriseId"
    }
  }, _vm._l((_vm.entArr), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.companyName,
        "value": item.id
      }
    })
  }))], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "textLine clearfix"
  }, [_c('div', {
    staticClass: "itemGp"
  }, [_c('div', {
    staticClass: "iName"
  }, [_vm._v("身份")]), _vm._v(" "), _c('div', {
    staticClass: "iContent radioContent"
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.radioChange
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("普通用户")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("主管理员")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("子管理员")])], 1)], 1)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "pagefoot"
  }, [(_vm.pgState) ? _c('div', {
    staticClass: "loading"
  }, [(_vm.pgState == 1) ? _c('span', [_vm._v("初始化中...")]) : _vm._e(), _vm._v(" "), (_vm.pgState == 2) ? _c('span', [_vm._v("数据保存中...")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "el-icon-loading"
  })]) : _c('div', [_c('el-button', {
    attrs: {
      "plain": "",
      "size": "small"
    },
    on: {
      "click": _vm.goReturn
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.directSave
    }
  }, [_vm._v("保存")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-5eb20c62"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/Enterprise/userMent/listEdit.vue
// module id = 1502
// module chunks = 1